// extracted by mini-css-extract-plugin
export default {"ShopCollection":"ShopCollection_ShopCollection__zUYH0"};